/**
 * Collapse a list of page numbers into a compact human range: `[1,2,3,7]` →
 * `"1-3, 7"`.
 *
 * Used to say WHICH pages a run's duration covers. One OCR run reads a whole
 * batch of pages in one model call and reports one `duration_ms`, and the
 * results sheet printed it beside the first page's field count — where it read
 * as "page 1 took 1m 37s" for a number that is the entire run's.
 *
 * Always ASCII digits and a plain hyphen: the value is rendered inside a
 * `dir='auto'` line, and Arabic-Indic digits here would fight the surrounding
 * bidi resolution for no benefit.
 */
export function formatPageRanges(pages: number[]): string {
  const sorted = [...new Set(pages)]
    .filter((page) => Number.isInteger(page) && page > 0)
    .sort((a, b) => a - b);

  if (sorted.length === 0) return '';

  const parts: string[] = [];
  let start = sorted[0];
  let previous = sorted[0];

  for (const page of sorted.slice(1)) {
    if (page === previous + 1) {
      previous = page;
      continue;
    }
    parts.push(start === previous ? `${start}` : `${start}-${previous}`);
    start = page;
    previous = page;
  }

  parts.push(start === previous ? `${start}` : `${start}-${previous}`);

  return parts.join(', ');
}
